(function() {
  'use strict';

  // i18n() is a no-op marker so the extraction script can find these keys.
  function i18n(key) { return key; }

  var goalsStates = {
    inProgress: {
      id: 'inProgress',
      name: i18n('In progress'),
      labelStyle: 'warning',
      borderStyle: 'pending'
    },
    carriedForward: {
      id: 'carriedForward',
      name: i18n('Carried forward'),
      labelStyle: 'danger',
      borderStyle: 'danger'
    },
    partiallyAchieved: {
      id: 'partiallyAchieved',
      name: i18n('Partially achieved'),
      labelStyle: 'success',
      borderStyle: 'complete'
    },
    notAchieved: {
      id: 'notAchieved',
      name: i18n('Not achieved'),
      labelStyle: 'danger',
      borderStyle: 'danger'
    },
    achieved: {
      id: 'achieved',
      name: i18n('Achieved'),
      labelStyle: 'success',
      borderStyle: 'complete'
    }
  };

  angular.module('component.goals')
    .constant('GOALS_STATES', goalsStates);
})();
